export const AppConstants = {
    DISPENSER_URL_ROOT: 'https://dispenser.caninesunleashedinc.com' ,
    DEFAULT_ROOM_ID:'101',
    REQUEST_STATUS_INITIATED:10,
    REQUEST_STATUS_COMPLETED:20,
    REQUEST_STATUS_EXPIRED: 30,
    NULL_DATE_STR:"1970-01-01T00:00:00",
    ONESIGNAL_APP_ID:"5e99273a-e4d0-4f9c-b245-c124ff1f9b9c", //"ce1e82ac-05a0-4b3e-b947-4dde76ab76f7"
};
